import { FEATURE_FLAGS } from '../constants/feature-flags';
import { ValuesOf } from '../types';
import { FfsFlag } from '@ringcentral/feature-flag-service';
import { FeatureFlagController } from './interface/feature-flag-controller';

export type FeatureFlagKey = ValuesOf<typeof FEATURE_FLAGS>;

export type FeatureFlag =
    | FfsFlag
    | (string | number | boolean | Record<string, unknown> | number[] | string[])
    | null;

export type OverrideFeatureFlag = Partial<Record<FeatureFlagKey, boolean>>;

// app.config.js FEATURES
export type RWCConfigFeatureEntity = {
    enabled: boolean;
    /** @deprecated */
    idAccounts?: Array<string>;
    [key: string]: unknown;
};

export type FeatureFlagIdentifyInfo = {
    extension: number;
    email: string;
    accountId: number;
};

export enum FeatureFlagEvent {
    /**
     * initialized include (success and failed),as long as it is not in pending state
     */
    INITIALIZED = 'initialized',
    /**
     * feature flag controller fetch success
     */
    SUCCEED = 'succeed',
    /**
     * feature flag changed
     */
    CHANGED = 'changed',
    /**
     * feature flag controller fetch failed
     */
    FAILED = 'failed',
}

export enum FeatureFlagSourceName {
    FFS = 'ffs',
}

export type QueryOptions = {
    method: string;
    url: string;
    query?: Record<string, unknown>;
    body?: Record<string, unknown>;
    headers?: Record<string, unknown>;
    credentials?: string;
    skipAuthCheck?: boolean;
};

export type ExternalFlagType = 'FFS';

export type RWCExternalConfigFeatureEntity = RWCConfigFeatureEntity & {
    key: string;
    type?: ExternalFlagType;
};

export type FFSFetchFn = (options: QueryOptions) => Promise<Response> | undefined;

export type FeatureFlagTransform = (flag: FeatureFlag) => FeatureFlag;

export type FeatureFlagSource = {
    priority: number;
    transform: FeatureFlagTransform;
    controller: FeatureFlagController;
};

export type FeatureFlagsMap = Partial<
    Record<
        FeatureFlagKey,
        { originKey: string; featureFlag: FeatureFlag; source: FeatureFlagSourceName }
    >
>;
